import { render, staticRenderFns } from "./justOne.vue?vue&type=template&id=77f2722c&scoped=true&"
import script from "./justOne.vue?vue&type=script&lang=js&"
export * from "./justOne.vue?vue&type=script&lang=js&"
import style0 from "./justOne.vue?vue&type=style&index=0&id=77f2722c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f2722c",
  null
  
)

export default component.exports